import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class LoaderService {
	/** Bandera observable para saber cuando termina de cargarse la solicitud http. */
	public isLoading$: Observable<boolean>;
	/** Bandera inyectable del estado actual de carga y que se mostrará en el observable isLoading$. */
	private _isLoading$: BehaviorSubject<boolean>;
	/** Vista cargando mientras haya alguna petición. */
	private currentRequests = 0;
	constructor() {
		this._isLoading$ = new BehaviorSubject(false);
		this.isLoading$ = this._isLoading$.asObservable();
	}

	show() {
		this.currentRequests++;
		if (this.currentRequests === 1) this._isLoading$.next(true);
	}

	hide() {
		if (this.currentRequests > 0) this.currentRequests--;
		if (this.currentRequests === 0) this._isLoading$.next(false);
	}
}
